// extracted by mini-css-extract-plugin
export default {"overlay":"BotModal_overlay__hAuet","modal":"BotModal_modal__JEvEA","detailList":"BotModal_detailList__pULc9","footer":"BotModal_footer__b1JsA"};